var map = {
	"./OLD_egg_stars.svg": "3f2b",
	"./OLD_egg_wind.svg": "e1e8",
	"./OLDegg_flames.svg": "4d8f",
	"./OLDegg_sparkles.svg": "7467",
	"./background.svg": "fe6a",
	"./background_mountains.svg": "4ee8",
	"./background_sky.svg": "ab45",
	"./egg_flames.svg": "6f6b",
	"./egg_nest.svg": "83b7",
	"./egg_sparkles.svg": "5418",
	"./egg_stars.svg": "990f",
	"./egg_wind.svg": "9d67",
	"./life.svg": "a792",
	"./life_dim.svg": "6734",
	"./scroll_question.svg": "f98a",
	"./scroll_score.svg": "6b51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e751";